import fetch from 'tools/fetch'
import { makeQueryString } from 'tools/routes'

const newTranslation = '/newTranslations'

export const getNewTranslationApi = async ({ req, origin, apiRoot, lang }) => {
  try {
    const translations = await fetch(`${origin(req)}${apiRoot}${newTranslation}${makeQueryString({ lang })}`)
    return translations
  } catch (_) {
    return {}
  }
}
